module.exports = __webpack_public_path__ + "static/media/bl.02993db0.svg";